<template>
  <kst-section collapsible collapsed info-mode
    :title="sectionTitle"
    :help-collapsed="sectionHelp"
  >
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="details"
      dateField="ReceiveDate"
      numberField="ReceiveID"
    />
  </kst-section>
</template>

<script>
import Catalog from "../RrcvCatalog.js";
import Info from "../RrcvInfo.js";
import Model from "../RrcvModel.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionHelp() {
      return Model.getReceiveSectionHelp(this.details);
    },
    sectionTitle() {
      return Info.Section.Receive.Title;
    }
  }
}
</script>